module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tipBox"
  }, [_c('div', {
    staticClass: "tipInfoBox",
    class: _vm.data.link ? 'onlyTip' : ''
  }, [_c('span', [_vm._v(_vm._s(_vm.data.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3083ed38","hasScoped":false}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipBox.vue
// module id = 317
// module chunks = 1